// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HMKF","toggle":"styles_toggle__2Kb46","preview":"styles_preview__1HbOF"};